import { DatePipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule as SharedModuleNG } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RippleModule } from 'primeng/ripple';
import { ToastComponent } from './components/toast/toast.component';
import { ByPassSecurityPipe } from './pipes/bypass-security.pipe';
import { SortAuctionsPipe } from './pipes/sort-auctions.pipe';

@NgModule({
  declarations: [
    // ShellRenderDirective,
    // ShellNoRenderDirective,
    // SortAuctionsPipe,
    // ToastComponent,
    ByPassSecurityPipe,
    // StartConversationComponent,
  ],
  imports: [
    ToastComponent,
    // CommonModule,
    FontAwesomeModule,
    NgbModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    // CarouselModule,
    // RouterModule,
    SharedModuleNG,
    RippleModule,
  ],
  exports: [
    TranslateModule,
    NgbModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModuleNG,

    // ShellRenderDirective,
    // ShellNoRenderDirective,
    // SortAuctionsPipe,
    // ByPassSecurityPipe,
    // StartConversationComponent,
  ],
  providers: [DecimalPipe, DatePipe, SortAuctionsPipe, ByPassSecurityPipe],
})
export class SharedModule {}
